import React from 'react'

export default ({ numPages, activePage }) => {
  if (!numPages) {
    return null
  }

  let pages = []
  for (let i = 0; i < numPages; ++i) {
    pages.push(
      <div
        key={`page-${i + 1}`}
        className={`pager--page ${activePage === i ? 'active' : null}`}
      />
    )
  }

  return <div className="pager">{pages}</div>
}
